/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Display_Delete_Records_ConfirmInputs */

const en_explorer_display_delete_records_confirm = /** @type {(inputs: Explorer_Display_Delete_Records_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes, delete them`)
};

const fr_explorer_display_delete_records_confirm = /** @type {(inputs: Explorer_Display_Delete_Records_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui, les supprimer`)
};

const de_explorer_display_delete_records_confirm = /** @type {(inputs: Explorer_Display_Delete_Records_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja, lösche sie.`)
};

const it_explorer_display_delete_records_confirm = /** @type {(inputs: Explorer_Display_Delete_Records_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì, eliminali`)
};

const ru_explorer_display_delete_records_confirm = /** @type {(inputs: Explorer_Display_Delete_Records_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Да, удалите их.`)
};

const es_explorer_display_delete_records_confirm = /** @type {(inputs: Explorer_Display_Delete_Records_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí, elimínalos`)
};

const zh_cn2_explorer_display_delete_records_confirm = /** @type {(inputs: Explorer_Display_Delete_Records_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`是的，删除它们`)
};

const ja_explorer_display_delete_records_confirm = /** @type {(inputs: Explorer_Display_Delete_Records_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい、削除します`)
};

const hi_explorer_display_delete_records_confirm = /** @type {(inputs: Explorer_Display_Delete_Records_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हां, उन्हें हटा दें`)
};

const pt_pt2_explorer_display_delete_records_confirm = /** @type {(inputs: Explorer_Display_Delete_Records_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim, apague-os.`)
};

/**
* | output |
* | --- |
* | "Yes, delete them" |
*
* @param {Explorer_Display_Delete_Records_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_display_delete_records_confirm = /** @type {((inputs?: Explorer_Display_Delete_Records_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Display_Delete_Records_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_display_delete_records_confirm(inputs)
	if (locale === "de") return de_explorer_display_delete_records_confirm(inputs)
	if (locale === "it") return it_explorer_display_delete_records_confirm(inputs)
	if (locale === "ru") return ru_explorer_display_delete_records_confirm(inputs)
	if (locale === "es") return es_explorer_display_delete_records_confirm(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_display_delete_records_confirm(inputs)
	if (locale === "ja") return ja_explorer_display_delete_records_confirm(inputs)
	if (locale === "hi") return hi_explorer_display_delete_records_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_display_delete_records_confirm(inputs)
	return en_explorer_display_delete_records_confirm(inputs)
});